import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SharedFeedbackDetailData } from "../../modules/user/shared_feedback/typeSharedFeedbacks";
import { FeedbackDetailAPICallProps } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const sharedDraftDetail = createAsyncThunk(
  "feedback/shared/draft/detail",
  async (params: FeedbackDetailAPICallProps, storeActions) => {
    const url = `api/v1/user/feedbacks/shared/draft/detail?feedbackId=${params.feedbackId}`;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const sharedDraftDetailSlice = createSlice({
  name: "sharedDraftDetails",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as SharedFeedbackDetailData | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sharedDraftDetail.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(sharedDraftDetail.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(sharedDraftDetail.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = sharedDraftDetailSlice.actions;

export default sharedDraftDetailSlice;
